import React from "react";

const slides = [
  {
    id: "01",
    title: "Discovery",
    description:
      "We start by understanding your business goals, requirements, and challenges to create a roadmap for success.",
  },
  {
    id: "02",
    title: "Design",
    description:
      "Our team designs intuitive user interfaces and seamless user experiences tailored to your specific needs.",
  },
  {
    id: "03",
    title: "Development",
    description:
      "Built with rigorous code standards, peer review, and automated testing — engineered for real-world reliability, not just functional correctness.",
  },
  {
    id: "04",
    title: "Deployment",
    description:
      "Staged rollouts with CI/CD pipelines, load testing, and real-time monitoring — every release is validated before it reaches your users.",
  },
  {
    id: "05",
    title: "Maintenance",
    description:
      "Proactive monitoring, prompt issue resolution, and continuous optimization — we stay accountable for reliability long after go-live.",
  },
];

const ProcessCards = () => {
  return (
    <section id="our-process" className="bg-[#f8f8f8] py-24 px-6 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-['IBM_Plex_Mono'] text-[#F07023] text-xs tracking-[0.3em] uppercase">
            05 / Our Process
          </span>
          <h2 className="text-gray-900 text-[clamp(1.5rem,2.5vw,2.75rem)] font-[700] mt-4 leading-tight">
            From concept to launch and beyond
          </h2>
          <div className="w-12 h-px bg-[#F07023] mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {slides.map((slide) => (
            <div
              key={slide.id}
              className="group relative bg-transparent border border-gray-200 pl-6 pr-4 py-8 transition-all duration-300 hover:border-t-2 hover:border-t-[#F07023] hover:border-[#F07023]/30"
            >
              <span className="absolute top-0 right-0 w-4 h-4 border-t border-r border-[#F07023]/30" />
              <span className="font-['IBM_Plex_Mono'] text-[4rem] font-[500] text-[#F07023]/15 leading-none block mb-6">
                {slide.id}
              </span>
              <h3 className="text-gray-900 text-lg font-[600] mb-3">{slide.title}</h3>
              <p className="text-gray-500 text-[0.9rem] leading-relaxed">{slide.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessCards;
